import { axiosInstance } from 'services';
import { AxiosResponse } from 'axios';

import { API_KEY } from 'constants/apis';
import { ORGANIZATIONS_GRAPH_NAMES } from 'constants/organizationsGraphNames';

import { IOrganizationsCategoriesResponse, IOrganizationsResponse } from 'types/interfaces';
import {activeMembersMock, orgCategoriesMock, orgsOverThresholdAumMock, orgsOverThresholdMock, potentialVotersMock, totalTreasuryMock, dashboardOrgsMock} from '../../mockedData/mainPage';

export const OrganizationsApi = {
    // getOrganizationsData: (
    //     offset = 0,
    //     limit = 200,
    //     orderBy = 'totalValueUSD',
    //     paginationOrderDescending: boolean,
    // ): Promise<AxiosResponse<IOrganizationsResponse>> =>
    //     axiosInstance.get<IOrganizationsResponse>(
    //         `dashboard/${API_KEY}?limit=${limit}&offset=${offset}&orderBy=${orderBy}&order=${
    //             paginationOrderDescending ? 'DESC' : 'ASC'
    //         }`,
    //     ),
    getOrganizationsData: (
      offset = 0,
      limit = 50,
      orderBy = 'totalValueUSD',
      paginationOrderDescending: boolean,
  ): Promise<AxiosResponse<any>> => {
    const mockResponse: AxiosResponse<any> = {
      data: {
        ...dashboardOrgsMock
      },
      status: 200,
      statusText: "OK",
      headers: {},
      config: {},
      request: {},
    };
  
    return Promise.resolve(mockResponse);
  },
    // getOrganizationsGraphData: (name: ORGANIZATIONS_GRAPH_NAMES): Promise<AxiosResponse<unknown>> =>
    //     axiosInstance.get<unknown>(`dashboard/${API_KEY}/graph/${name}`),
    getOrganizationsGraphData: (name: ORGANIZATIONS_GRAPH_NAMES): Promise<AxiosResponse<unknown>> => {
        
        let mockData: unknown;
        switch (name) {
          case ORGANIZATIONS_GRAPH_NAMES.TOTAL_TREASURY:
            mockData = totalTreasuryMock;
            break;
          
          case ORGANIZATIONS_GRAPH_NAMES.ORGS_THRESHOLD_TOKEN_HOLDERS:
            mockData = orgsOverThresholdMock;
            break;
          
          case ORGANIZATIONS_GRAPH_NAMES.POTENTIAL_VOTERS:
            mockData = potentialVotersMock;
            break;

          case ORGANIZATIONS_GRAPH_NAMES.ACTIVE_MEMBERS:
            mockData = activeMembersMock;
            break;

          case ORGANIZATIONS_GRAPH_NAMES.ORGS_THRESHOLD_AUM:
            mockData = orgsOverThresholdAumMock;
            break;

          default:
            mockData = { message: `No mock data for graph ${name}` };
        }

        const mockResponse: AxiosResponse<unknown> = {
          data: mockData,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        };
      
        return Promise.resolve(mockResponse);
        
      },
    // getOrganizationsCategories: (): Promise<AxiosResponse<IOrganizationsCategoriesResponse>> =>
    // axiosInstance.get<IOrganizationsCategoriesResponse>('ecosystem-category/organization-categories'),
    getOrganizationsCategories: (): Promise<AxiosResponse<IOrganizationsCategoriesResponse>> => {
        
        const mockResponse: AxiosResponse<IOrganizationsCategoriesResponse> = {
          data: {
            ...orgCategoriesMock
          },
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        };
      
        return Promise.resolve(mockResponse);
      
    }
};
